import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
  ChipComponent,
  DataListComponent,
  FilterAreaComponent,
  ItemListComponent,
  PaginationComponent
} from '@shared/module/data-list/component';
import {TranslateModule} from '@ngx-translate/core';
import {FormsModule} from '@angular/forms';
import {SerenityPipeModule} from '@pipe';
import {SerenityDirectiveModule} from '@shared/module/serenity-directive/serenity-directive.module';
import {DataDetailComponent} from './component/data-detail/data-detail.component';
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";


@NgModule({
  declarations: [
    ChipComponent,
    DataListComponent,
    FilterAreaComponent,
    PaginationComponent,
    DataDetailComponent,
    ItemListComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    SerenityPipeModule,
    SerenityDirectiveModule,
    MatProgressSpinnerModule
  ],
  exports: [
    DataListComponent,
    FilterAreaComponent,
    PaginationComponent,
    DataDetailComponent,
    ItemListComponent
  ]
})
export class DataListModule {
}
